module.exports = __webpack_public_path__ + "api-card-icon.png?6106b1896a4577ddf2a324ce01030b52";